import { createEvent, createStore } from 'effector';
import { Toast } from './toast.types';

export const abrirToast = createEvent<Toast>();
export const fecharToast = createEvent();

export const $toastStore = createStore<Toast>({ titulo: '', mensagem: '', status: 'success', visible: false })
  .on(abrirToast, (_, payload) => payload)
  .on(fecharToast, () => ({ titulo: '', mensagem: '', status: 'success', visible: false }));
